import React from 'react';
import './CarouselControls.css';

const ChevronLeft = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 6l-6 6 6 6" />
  </svg>
);

const ChevronRight = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 6l6 6-6 6" />
  </svg>
);

// Standard carousel/slideshow control bar: prev arrow, dot indicator pill, next
// arrow. Dot width/opacity/color are left to the caller to drive imperatively
// via `dotRefs` (each carousel has its own scroll-position math), so this
// component only owns the shared markup and styling.
const CarouselControls = ({
  count,
  activeIndex,
  dotRefs,
  getLabel = (i) => `Slide ${i + 1}`,
  onDotClick,
  onPrev,
  onNext,
  prevDisabled = false,
  nextDisabled = false,
}) => (
  <div className="carousel-controls">
    <button
      type="button"
      className="carousel-arrow"
      onClick={onPrev}
      disabled={prevDisabled}
      aria-label="Previous"
    >
      <ChevronLeft />
    </button>

    <div className="carousel-dots">
      {Array.from({ length: count }).map((_, i) => (
        <button
          key={i}
          ref={dotRefs ? (el) => { dotRefs.current[i] = el; } : undefined}
          type="button"
          className="carousel-dot"
          onClick={() => onDotClick(i)}
          aria-label={getLabel(i)}
          aria-current={i === activeIndex}
        />
      ))}
    </div>

    <button
      type="button"
      className="carousel-arrow"
      onClick={onNext}
      disabled={nextDisabled}
      aria-label="Next"
    >
      <ChevronRight />
    </button>
  </div>
);

export default CarouselControls;
